import React from 'react';
import Reveal from './Reveal';

// Reusable inner-page hero header with image + overlay.
const PageHeader = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section className="relative h-[62vh] min-h-[440px] w-full overflow-hidden">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover kenburns" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/75" />
      <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-end pb-16">
        <Reveal>
          <div className="eyebrow text-amber-400 mb-5 flex items-center gap-3">
            <span className="w-8 h-px bg-amber-400" /> {eyebrow}
          </div>
        </Reveal>
        <Reveal delay={120}>
          <h1 className="font-display font-bold text-white text-4xl md:text-6xl lg:text-7xl tracking-[0.04em] leading-none break-words">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={240}>
            <p className="mt-6 max-w-2xl text-neutral-200 text-base md:text-lg font-light leading-relaxed">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
